import axiosInstance from './axios.instance'

export const GET_KNOWLEDGE = async () => {
  try {
    const res = await axiosInstance.get('/ai-knowledge')
    return res.data
  } catch (err) {
    console.error('GET_KNOWLEDGE error', err)
    throw err
  }
}

export const POST_WEBSITE_KNOWLEDGE = async ({
  agentId,
  sourceName,
  KnowledgeUrl,
}) => {
  try {
    const payload = {
      KnowledgeUrl,
      agentId,
      sourceName,
    }
    const res = await axiosInstance.post('/ai-knowledge/website', payload)
    return res.data
  } catch (err) {
    console.error('POST_WEBSITE_KNOWLEDGE error', err)
    throw err
  }
}

export const POST_DOCUMENT_KNOWLEDGE = async ({
  sourceName,
  agentId,
  documentUrl,
}) => {
  try {
    const payload = {
      sourceName,
      agentId,
      KnowledgeUrl: documentUrl,
    }
    const res = await axiosInstance.post('/ai-knowledge/document', payload)
    return res.data
  } catch (err) {
    console.error('POST_DOCUMENT_KNOWLEDGE error', err)
    throw err
  }
}

export const GET_AI_AGENTS = async (filters = {}) => {
  try {
    const res = await axiosInstance.get('/ai-agent', { params: filters })
    return res.data
  } catch (err) {
    console.error('GET_AI_AGENTS error', err)
    throw err
  }
}

export const GET_AI_AGENT_BY_ID = async (id) => {
  try {
    const res = await axiosInstance.get(`/ai-agent/${id}`)
    return res.data
  } catch (err) {
    console.error('GET_AI_AGENT_BY_ID error', err)
    throw err
  }
}

export const GET_POLL_STATUS = async (jobId) => {
  try {
    const res = await axiosInstance.get(`/ai-knowledge/poll/${jobId}`)
    return res.data
  } catch (err) {
    console.error('GET_POLL_STATUS error', err)
    throw err
  }
}

export const STOP_POLL_JOB = async (jobId) => {
  try {
    const res = await axiosInstance.post(`/ai-knowledge/poll/${jobId}/stop`)
    return res.data
  } catch (err) {
    console.error('STOP_POLL_JOB error', err)
    throw err
  }
}

export const DELETE_KNOWLEDGE = async (id) => {
  try {
    const res = await axiosInstance.delete(`/ai-knowledge/${id}`)
    return res.data
  } catch (err) {
    console.error('DELETE_KNOWLEDGE error', err)
    throw err
  }
}

export const POST_AI_AGENT = async (payload) => {
  try {
    const res = await axiosInstance.post('/ai-agent', payload)
    return res.data
  } catch (err) {
    console.error('POST_AI_AGENT error', err)
    throw err
  }
}

export const EXECUTE_AI_AGENT = async (payload) => {
  try {
    const res = await axiosInstance.post('/ai-agent/execute', payload)
    return res.data
  } catch (err) {
    console.error('EXECUTE_AI_AGENT error', err)
    throw err
  }
}

export const PUT_AI_AGENT = async (id, payload) => {
  try {
    const res = await axiosInstance.put(`/ai-agent/${id}`, payload)
    return res.data
  } catch (err) {
    console.error('PUT_AI_AGENT error', err)
    throw err
  }
}

export const DELETE_AI_AGENT = async (id, payload) => {
  try {
    const config = payload ? { data: payload } : undefined
    const res = await axiosInstance.put(`/ai-agent/${id}`, config)
    return res.data
  } catch (err) {
    console.error('DELETE_AI_AGENT error', err)
    throw err
  }
}
